import styled from "styled-components";

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #6bbfbf;
  min-width: 100%;

  //Responsive HeaderContainer
  @media (max-width: 768px) {
    width: 100%;
  }

  @media (max-width: 425px) {
    max-width: 100%;
  }
`;

export const ContentHeader = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 0;
  max-width: 70rem;
  width: 100%;

  //Responsive ContentHeader
  @media (max-width: 1200px) {
    width: 100%;
    padding: 1rem 5rem;
  }

  @media (max-width: 425px) {
    padding: 0.5rem;
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  justify-content: space-between;

  form {
    display: flex;
    align-items: center;
    position: relative;

    img {
      cursor: pointer;
    }
  }

  div {
    display: flex;
    justify-content: space-between;
  }

  p {
    display: flex;
    align-items: center;
    margin-left: 0.5rem;
    font-size: 0.75rem;
    font-weight: 700;
    color: #460259;
    gap: 0.875rem;
  }

  .cartButton {
    position: relative;
    font-size: 0.75rem;
    font-weight: 700;
    color: #460259;

    span {
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f2b705;
      width: 1rem;
      height: 1rem;
      border-radius: 50%;
      position: absolute;
      top: -0.5rem;
      right: -0.5rem;
    }
  }

  //Responsive SearchContainer
  @media (max-width: 1125px) {
    .cartButton {
      font-size: 0.7rem;
    }
  }

  @media (max-width: 768px) {
    align-items: center;
    justify-content: space-between;

    div {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }
  }

  @media (max-width: 600px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0;

    form {
      padding: 0;
      width: 100%;
    }
  }
`;

export const CategoryContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: ${({ theme }) => theme.typography.fontFamily.primary};
  margin-top: 1rem;

  @media (max-width: 768px) {
    align-items: space-between;
    gap: 1rem;
  }

  ul {
    display: flex;
    align-items: center;
    gap: 1.25rem;
    list-style: none;

    li {
      font-size: 0.75rem;
      color: #460259;
      font-weight: 400;
    }
  }

  span {
    display: flex;
    align-items: center;
    padding-right: 1.25rem;
    font-size: 0.75rem;
    color: #460259;
    font-weight: 700;
    gap: 6px;

    button {
      display: flex;
      align-items: center;
      background: none;
      border: none;
      border-right: 1px solid rgba(70, 2, 89, 0.5);
      padding-right: 0.5rem;
    }
  }

  @media (max-width: 768px) {
    display: none;
  }
`;
